import { Box, IconButton, Tooltip } from '@material-ui/core';

import { useApplicationButtonIconStyles } from '@/components/modules/Application/hooks/useApplicationButtonIconStyles';
import { useApplicationNavigation } from '@/components/modules/Application/hooks/useApplicationNavigation';
import { useGetApplicationSteps } from '@/components/modules/Application/hooks/useGetApplicationSteps';
import { ActionDialog } from '@/components/shared/components/ActionDialog';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { useUIWrapper } from '@/hooks/useUIWrapper';

export const ApplicationRestart = () => {
  const { containerPadding, containerMaxWidth } = useUIWrapper();
  const { size, buttonStyles } = useApplicationButtonIconStyles();
  const { initApplication, resetNavigation } = useApplicationNavigation();
  const { getSteps } = useGetApplicationSteps();
  const { opened, setOpened, toggleDialog } = useDialog();

  const handleRestart = () => {
    initApplication();
    resetNavigation(getSteps());
    setOpened(false);
  };

  return (
    <Box
      position={'fixed'}
      top={0}
      right={0}
      zIndex={200}
      width={'min-content'}
      p={`35px ${containerPadding} 0`}
      maxWidth={containerMaxWidth}
    >
      <Tooltip title={<Text tId={'RESTART_APPLICATION'} />} placement="bottom">
        <IconButton onClick={() => setOpened(true)} style={buttonStyles}>
          <Icon size={size}>restart_alt</Icon>
        </IconButton>
      </Tooltip>
      <ActionDialog
        opened={opened}
        setOpened={setOpened}
        handleClose={toggleDialog}
        Title={<Text tId={'RESTART_APPLICATION'} />}
        onSubmit={handleRestart}
        Description={<Text tId={'RESTART_NOTICE'} />}
        MainButton={<Text tId={'RESTART'} />}
      />
    </Box>
  );
};
